import React, { useEffect, useState } from 'react'

const DISMISS_KEY = 'pwa_install_dismissed'

const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true

/**
 * Android/Chrome install banner. iOS uses react-ios-pwa-prompt in App.js.
 * beforeinstallprompt only fires when the manifest and service worker are installable.
 */
const PwaInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (isStandalone()) return undefined
    if (sessionStorage.getItem(DISMISS_KEY) === 'true') return undefined

    const onPrompt = (event) => {
      event.preventDefault()
      setDeferredPrompt(event)
      setVisible(true)
    }

    const onInstalled = () => {
      setVisible(false)
      setDeferredPrompt(null)
    }

    window.addEventListener('beforeinstallprompt', onPrompt)
    window.addEventListener('appinstalled', onInstalled)
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt)
      window.removeEventListener('appinstalled', onInstalled)
    }
  }, [])

  const install = async () => {
    if (!deferredPrompt) return
    deferredPrompt.prompt()
    try {
      await deferredPrompt.userChoice
    } catch {
      // User dismissed the native sheet.
    }
    setDeferredPrompt(null)
    setVisible(false)
  }

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, 'true')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[999998] mx-auto max-w-md rounded-xl bg-black text-white shadow-2xl p-4 flex items-center gap-3">
      <div className="flex-1">
        <p className="font-semibold text-sm">Install FarmerKonnect</p>
        <p className="text-xs text-white/70 mt-0.5">
          Add the app to your home screen for faster access and updates.
        </p>
      </div>
      <button
        type="button"
        onClick={dismiss}
        className="text-xs text-white/70 px-2 py-2"
      >
        Later
      </button>
      <button
        type="button"
        onClick={install}
        className="bg-yellowcolor text-black text-sm font-semibold px-4 py-2 rounded-lg"
      >
        Install
      </button>
    </div>
  )
}

export default PwaInstallPrompt
